<template lang="pug">
main.app-main
    keep-alive
        router-view(
            :disabled-create-audience="disabledCreateAudience"
            :showBeforeEditModal="showBeforeEditModal"
            @closeBeforeEditModal="showBeforeEditModal = false"
        )

    .overlay-close(
        v-if="formulaHasOnlyDeletedCriteria",
        @click="closeFormulaHasOnlyDeletedCriteriaModal()"
    )
    .modal.modal__small.modal-warning-emptyboxes(
        v-if="formulaHasOnlyDeletedCriteria"
    )
        ConfirmationModal(modalClassName="modal-wrapper")
            template(slot="content")
                div The audience's formula can not be edited because the criterias in the formula do not exist or are not available anymore
            template(slot="footer")
                .footer-content.l-flex-row--center.l-align-center
                    .btn.btn--medium(
                        @click="closeFormulaHasOnlyDeletedCriteriaModal()"
                    ) Ok
</template>

<script>
import { includes, isEqual } from 'lodash'

//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

import ConfirmationModal from '@/components/common/confirmationModal'

export default {
    name: 'Builder',

    components: { ConfirmationModal },

    data() {
        return {
            showBeforeEditModal: false
        }
    },

    computed: {
        // Call to state
        ...mapState('account', {
            accountId: state => state.accountId
        }),

        ...mapState('builder', {
            builderAudienceFormula: state => state.formula
        }),

        ...mapState('ui/builder', {
            ccloneFormula: state => state.formula.cclone,
            formulaExclusionBoxe: state => state.formula.exclusion,
            formulaInclusionBoxes: state => state.formula.inclusion,
            displayWarningModal: state => state.displayModal.warning,
            formulaHasOnlyDeletedCriteria: state => state.displayModal.formulaHasOnlyDeletedCriteria
        }),

        // Call to getters
        ...mapGetters('builder', ['inEditionMode', 'audienceInEdition']),
        ...mapGetters('ui/builder', ['getFormulaCriterionToBuilderFormat']),

        ...mapGetters('account', ['getAccessToBuilderSegment', 'getAccessToCclone', 'getIsAudienceCreationAllowed']),

        audienceType() {
            return includes(this.$route.path, 'segment') ? 'audience' : 'cclone'
        },

        disabledCreateAudience() {
            return (
                !this.getIsAudienceCreationAllowed({ mode: this.audienceType }) ||
                (this.builderAudienceFormula?.isEmpty && this.audienceType === 'audience') ||
                (this.ccloneFormula === null && this.audienceType === 'cclone') ||
                !this.editedVersionHasChange ||
                this.hasOnlyDisabledCriteria
            )
        },

        hasOnlyDisabledCriteria() {
            if (this.audienceType === 'cclone') return false
            let flatCriteria = []
            this.builderAudienceFormula?.boxes.forEach(box => {
                flatCriteria.push(...box?.criteria)
            })
            return flatCriteria.every(c => c.disabled)
        },

        hasUserAccessToBuilderSegment() {
            return this.getAccessToBuilderSegment()
        },

        hasUserAccessToCclone() {
            return this.getAccessToCclone()
        },

        displayNavBar() {
            return this.hasUserAccessToBuilderSegment || this.hasUserAccessToCclone
        },

        editedVersionHasChange() {
            let cleanedAudience = []
            const self = this
            //If there is Only 1 item it's in an object and can't forEach on it
            if (Array.isArray(this.audienceInEdition?.genericFormula)) this.audienceInEdition?.genericFormula.forEach(el => formatAudience(el))
            else formatAudience(this.audienceInEdition?.genericFormula)

            function formatAudience(audience) {
                const audienceOverrided = self.audienceGenericFormulaType(audience) ? self.changeAudienceName(audience) : audience
                cleanedAudience.push(audienceOverrided)
            }

            // When there is only one
            if (!Array.isArray(this.builderAudienceFormula?.v1)) {
                if (cleanedAudience[0] === '|' || cleanedAudience[0] === '&' || cleanedAudience[0] === '!') {
                    if (cleanedAudience.length === 2) {
                        cleanedAudience = this.audienceGenericFormulaType(cleanedAudience[1]) ? this.changeAudienceName(cleanedAudience[1]) : cleanedAudience[1]
                    }
                } else {
                    cleanedAudience = this.audienceGenericFormulaType(cleanedAudience[0]) ? this.changeAudienceName(cleanedAudience[0]) : cleanedAudience[0]
                }
            }
            if (!this.inEditionMode) return true // return true in create audience mode
            if (!this.inEditionMode && !this.audienceInEdition) return true
            return !isEqual(cleanedAudience, this.builderAudienceFormula.v1)
        }
    },

    methods: {
        ...mapActions('account', ['retrieveAccountId', 'retrieveItems']),

        ...mapActions('ui/builder', ['createAudienceForm']),

        ...mapMutations('ui/builder', ['setDisplayFormAudience', 'setDisplayModal', 'setIsEditingAudience', 'setEmptyFormula', 'setAudienceInEdtion']),

        changeViewName(name) {
            this.view_name = name
        },

        changeAudienceName(audience) {
            const behavioralName = `behavioral__${audience?.type.toLowerCase()}_${audience.ids[0]}`
            const wcmName = `media__campaigns__clicked_${audience.ids[0]}`
            if (audience?.type === 'Segment') return { ...audience, name: behavioralName }
            else if (audience?.type === 'WcmClick') return { ...audience, name: wcmName }
            else if (audience?.type === 'Techno' || audience?.type === 'Audience') {
                const ids = audience.ids.map(id => {
                    id = id.toString()
                    return id
                })
                return {
                    ...audience,
                    ids
                }
            }
            return audience
        },

        audienceGenericFormulaType(audience) {
            return audience?.type === 'Segment' || audience?.type === 'WcmClick' || audience?.type === 'Techno' || audience?.type === 'Audience'
        },

        checkCreateAudienceForm() {
            if (this.audienceType === 'cclone') {
                this.setDisplayFormAudience({
                    display: true,
                    mode: this.audienceType
                })
            } else {
                if (this.builderAudienceFormula.boxes.some(box => box.isEmpty)) {
                    this.setDisplayModal({ item: 'warning', display: true })
                } else {
                    this.inEditionMode ? (this.showBeforeEditModal = true) : this.createAudienceForm()
                }
            }
        },

        closeFormulaHasOnlyDeletedCriteriaModal() {
            this.setDisplayModal({
                item: 'formulaHasOnlyDeletedCriteria',
                display: false
            })
            this.setIsEditingAudience({ isEditing: false })
            this.setEmptyFormula()
        },

        audienceOperator(operator) {
            return operator !== '|' || operator !== '!' || operator !== '&'
        }
    }
}
</script>
